import { useEffect } from 'react';

import { Layout } from 'antd';
import { Form } from 'components';

import { useReducer } from 'lib/hooks/useReducer';

import { useDispatch } from 'react-redux';
import pcsInventories, { initialLoad, initialState } from './pcsSlice';

import { OutcomeMeasuresHeader } from 'components/header';

import { cleanPagedQuestionnaireStorage } from 'features/patient/assessment/_utils/questionnaire-local-storage';
import { setFaqObject } from 'navigation/utils/navigationSlice';
import { PaginationCombined } from './pcs-pagination-combined';

export function PatientPcs() {
  const faqDispatch = useDispatch();
  // const progressBarDispatch = useDispatch();
  const [{ pcs }, dispatch] = useReducer(pcsInventories, initialState);

  // create pcsrepo
  useEffect(() => {
    dispatch(initialLoad());
    faqDispatch(
      setFaqObject({
        min: pcs.min,
        max: pcs.max,
        description: pcs.description,
        instructions: pcs.instructions
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout style={{ backgroundColor: 'white' }}>
      <OutcomeMeasuresHeader
        label={'Exit'}
        title="3rd Questionnaire"
        onExit={() => {
          cleanPagedQuestionnaireStorage('questionnaire-pcs');
        }}
      />
      <Form>
        {<PaginationCombined storageKey={'questionnaire-pcs'} />}
        {/*<FormModal
          visible={showModal}
          onClose={() => dispatch(closeModal())}
          onGoto={() => reduxDispatch(push(Routes.PatientOutcomeMeasures))}
          gotoLabel="Proceed to next step"
        />*/}
      </Form>
    </Layout>
  );
}
